const ChartCard = ({
    title,
    children,
  }) => {
    return (
      <div className="bg-white dark:bg-gray-800 shadow-lg rounded-lg p-6 flex-1">
        <h2 className="text-xl font-semibold mb-4 text-indigo-600 dark:text-orange-400">
          {title}
        </h2>
  
        {children}
      </div>
    );
  };
  
  export default ChartCard;